module.exports = __webpack_public_path__ + "img/1.10.pH.5fc3d90d.png";